"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lecco": {
    "e549a0a8": [{
      "hkey": "8cb85700",
      "slug": "belledo",
      "name": "Belledo",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "0f44135d",
      "slug": "caleotto",
      "name": "Caleotto",
      "primary": false,
      "skipSearch": false
    }],
    "belledo-caleotto": [{
      "hkey": "8cb85700",
      "slug": "belledo",
      "name": "Belledo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "ba77494d": [{
      "hkey": "4aba29ec",
      "slug": "bonacina-ceredo",
      "name": "Bonacina-Ceredo",
      "primary": true,
      "skipSearch": false
    }],
    "bonacina": [{
      "hkey": "4aba29ec",
      "slug": "bonacina-ceredo",
      "name": "Bonacina-Ceredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "53b8d293": [{
      "hkey": "e95ffa66",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centralissimo": [{
      "hkey": "e95ffa66",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "80b5c2a5": [{
      "hkey": "e7b9c631",
      "slug": "laorca-malavedo",
      "name": "Laorca-Malavedo",
      "primary": true,
      "skipSearch": false
    }],
    "laorca": [{
      "hkey": "e7b9c631",
      "slug": "laorca-malavedo",
      "name": "Laorca-Malavedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "52fa8060": [{
      "hkey": "1c82526f",
      "slug": "maggianico",
      "name": "Maggianico",
      "primary": true,
      "skipSearch": false
    }],
    "maggianico-s-ambrogio": [{
      "hkey": "1c82526f",
      "slug": "maggianico",
      "name": "Maggianico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "450cb0c9": [{
      "hkey": "e7b9c631",
      "slug": "laorca-malavedo",
      "name": "Laorca-Malavedo",
      "primary": true,
      "skipSearch": false
    }],
    "malavedo": [{
      "hkey": "e7b9c631",
      "slug": "laorca-malavedo",
      "name": "Laorca-Malavedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "0a9fd2e8": [{
      "hkey": "e7b9c631",
      "slug": "laorca-malavedo",
      "name": "Laorca-Malavedo",
      "primary": true,
      "skipSearch": false
    }],
    "malavedo-laorca": [{
      "hkey": "e7b9c631",
      "slug": "laorca-malavedo",
      "name": "Laorca-Malavedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c669003b": [{
      "hkey": "e04e8c47",
      "slug": "falghera-malnago",
      "name": "Falghera-Malnago",
      "primary": true,
      "skipSearch": false
    }],
    "malnago": [{
      "hkey": "e04e8c47",
      "slug": "falghera-malnago",
      "name": "Falghera-Malnago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2d870645": [{
      "hkey": "9bea541d",
      "slug": "olate-san-giovanni",
      "name": "Olate-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "olate": [{
      "hkey": "9bea541d",
      "slug": "olate-san-giovanni",
      "name": "Olate-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dc8c8ce7": [{
      "hkey": "9bea541d",
      "slug": "olate-san-giovanni",
      "name": "Olate-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "s-giovanni-olate": [{
      "hkey": "9bea541d",
      "slug": "olate-san-giovanni",
      "name": "Olate-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "c90b962e": [{
      "hkey": "36999947",
      "slug": "lungolago-santo-stefano-turati",
      "name": "Lungolago-Santo Stefano-Turati",
      "primary": true,
      "skipSearch": false
    }],
    "s-stefano-zona-turati": [{
      "hkey": "36999947",
      "slug": "lungolago-santo-stefano-turati",
      "name": "Lungolago-Santo Stefano-Turati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4c97118c": [{
      "hkey": "9bea541d",
      "slug": "olate-san-giovanni",
      "name": "Olate-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "9bea541d",
      "slug": "olate-san-giovanni",
      "name": "Olate-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }],
    "a8d3a0f2": [{
      "hkey": "36999947",
      "slug": "lungolago-santo-stefano-turati",
      "name": "Lungolago-Santo Stefano-Turati",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "36999947",
      "slug": "lungolago-santo-stefano-turati",
      "name": "Lungolago-Santo Stefano-Turati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecco"
    }]
  }
};
exports["default"] = _default;